export default __webpack_public_path__ + "static/media/risk_level_0.fdf82b28.png";